import { 
  doc, 
  setDoc, 
  getDoc, 
  onSnapshot 
} from 'firebase/firestore';
import { db } from '../config/firebase';

export const userSettingsService = {
  // Save user settings to Firestore
  async saveUserSettings(userId, settings) {
    try {
      const settingsRef = doc(db, 'userSettings', userId);
      await setDoc(settingsRef, {
        ...settings,
        userId,
        updatedAt: new Date()
      }, { merge: true });
      
      console.log('✅ User settings saved:', settings);
      return { success: true };
    } catch (error) {
      console.error('❌ Error saving user settings:', error);
      return { success: false, error: error.message };
    }
  },

  // Get user settings from Firestore
  async getUserSettings(userId) {
    try {
      const settingsRef = doc(db, 'userSettings', userId);
      const settingsSnap = await getDoc(settingsRef);
      
      if (settingsSnap.exists()) {
        const settings = settingsSnap.data();
        console.log('✅ User settings loaded:', settings);
        return { success: true, settings };
      } else {
        // Return default settings if none exist
        const defaultSettings = {
          notifications: true,
          darkMode: false,
          autoPlay: true,
          emailUpdates: true,
          progressReminders: false,
        };
        console.log('📋 Using default settings for user');
        return { success: true, settings: defaultSettings };
      }
    } catch (error) {
      console.error('❌ Error getting user settings:', error);
      return { success: false, error: error.message };
    }
  },

  // Set up real-time listener for user settings
  subscribeToUserSettings(userId, callback) {
    const settingsRef = doc(db, 'userSettings', userId);
    
    console.log('🔥 Setting up real-time user settings listener...');
    
    const unsubscribe = onSnapshot(settingsRef, 
      (doc) => {
        if (doc.exists()) {
          const settings = doc.data();
          console.log('⚙️ User settings updated in real-time:', settings);
          callback({ success: true, settings });
        } else {
          // Use default settings if document doesn't exist
          const defaultSettings = {
            notifications: true,
            darkMode: false,
            autoPlay: true,
            emailUpdates: true,
            progressReminders: false,
          };
          callback({ success: true, settings: defaultSettings });
        }
      },
      (error) => {
        console.error('❌ Real-time settings listener error:', error);
        callback({ success: false, error: error.message });
      }
    );

    return unsubscribe;
  },

  // Save user progress data
  async saveUserProgress(userId, progressData) {
    try {
      const progressRef = doc(db, 'userProgress', userId);
      await setDoc(progressRef, {
        ...progressData,
        userId,
        updatedAt: new Date()
      }, { merge: true });
      
      console.log('✅ User progress saved');
      return { success: true };
    } catch (error) {
      console.error('❌ Error saving user progress:', error);
      return { success: false, error: error.message };
    }
  },

  // Get user progress data
  async getUserProgress(userId) {
    try {
      const progressRef = doc(db, 'userProgress', userId);
      const progressSnap = await getDoc(progressRef);
      
      if (progressSnap.exists()) {
        return { success: true, progress: progressSnap.data() };
      } else {
        return { success: true, progress: {} };
      }
    } catch (error) {
      console.error('❌ Error getting user progress:', error);
      return { success: false, error: error.message };
    }
  }
};
